import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export function NewProspectForm({ form, setForm, creating, onSubmit, onCancel }) {
  return (
    <form onSubmit={onSubmit} className="mb-10 p-6 border border-ink-900/12 rounded-md bg-white/55 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="new-prospect-form">
      <div className="md:col-span-2">
        <label className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55 mb-1 block">Company name *</label>
        <Input data-testid="new-company" value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })}
               placeholder="Acme Financial"
               className="bg-white/70 border-ink-900/12 text-ink-900 placeholder:text-ink-900/45 h-11 focus-visible:border-sun-500 focus-visible:ring-sun-500" />
      </div>
      <div>
        <label className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55 mb-1 block">Contact name</label>
        <Input data-testid="new-contact-name" value={form.contact_name} onChange={(e) => setForm({ ...form, contact_name: e.target.value })}
               className="bg-white/70 border-ink-900/12 text-ink-900 h-11 focus-visible:border-sun-500 focus-visible:ring-sun-500" />
      </div>
      <div>
        <label className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55 mb-1 block">Contact email</label>
        <Input data-testid="new-contact-email" type="email" value={form.contact_email} onChange={(e) => setForm({ ...form, contact_email: e.target.value })}
               className="bg-white/70 border-ink-900/12 text-ink-900 h-11 focus-visible:border-sun-500 focus-visible:ring-sun-500" />
      </div>
      <div className="md:col-span-2">
        <label className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55 mb-1 block">Logo URL (optional)</label>
        <Input data-testid="new-logo" value={form.logo_url} onChange={(e) => setForm({ ...form, logo_url: e.target.value })}
               placeholder="https://…/logo.png"
               className="bg-white/70 border-ink-900/12 text-ink-900 placeholder:text-ink-900/45 h-11 focus-visible:border-sun-500 focus-visible:ring-sun-500" />
      </div>
      <div className="md:col-span-2">
        <label className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55 mb-1 block">Private notes (only you see these)</label>
        <Textarea data-testid="new-notes" rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })}
                  className="bg-white/70 border-ink-900/12 text-ink-900 focus-visible:border-sun-500 focus-visible:ring-sun-500" />
      </div>
      <div className="md:col-span-2 flex gap-3 justify-end">
        <Button type="button" variant="ghost" onClick={onCancel} className="text-ink-900/70 hover:text-ink-900 hover:bg-cream/5">Cancel</Button>
        <Button type="submit" disabled={creating} data-testid="new-prospect-submit"
                className="bg-sun-500 hover:bg-sun-400 text-ink-900 font-medium">
          {creating ? "Creating…" : "Create prospect"}
        </Button>
      </div>
    </form>
  );
}
